module.exports = __webpack_public_path__ + "static/media/battery_60.bfac2540.svg";